var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScraperIntIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 2.33464H10.35C10 1.36797 9.08333 0.667969 8 0.667969C6.91667 0.667969 6 1.36797 5.65 2.33464H2.16667C2.05 2.33464 1.94167 2.34297 1.83333 2.36797C1.50833 2.43464 1.21667 2.6013 0.991667 2.8263C0.841667 2.9763 0.716667 3.15964 0.633333 3.35964C0.55 3.5513 0.5 3.76797 0.5 4.0013V15.668C0.5 15.893 0.55 16.118 0.633333 16.318C0.716667 16.518 0.841667 16.693 0.991667 16.8513C1.21667 17.0763 1.50833 17.243 1.83333 17.3096C1.94167 17.3263 2.05 17.3346 2.16667 17.3346H13.8333C14.75 17.3346 15.5 16.5846 15.5 15.668V4.0013C15.5 3.08464 14.75 2.33464 13.8333 2.33464ZM7.16667 11.643L5.99167 12.8263L3 9.83464L5.99167 6.84297L7.16667 8.0263L5.35833 9.83464L7.16667 11.643ZM8 3.3763C7.65833 3.3763 7.375 3.09297 7.375 2.7513C7.375 2.40964 7.65833 2.1263 8 2.1263C8.34167 2.1263 8.625 2.40964 8.625 2.7513C8.625 3.09297 8.34167 3.3763 8 3.3763ZM10.0083 12.8263L8.83333 11.643L10.6417 9.83464L8.83333 8.0263L10.0083 6.84297L13 9.83464L10.0083 12.8263Z",
    fill: "#535A60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScraperIntIcon);
export default __webpack_public_path__ + "static/media/scraperIntIcon.9157e828148ecc567153cd0bf8794111.svg";
export { ForwardRef as ReactComponent };